import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
} from "@mui/material"
import { DollarSign, CheckCircle, XCircle } from "lucide-react"
import { NavLink } from "react-router-dom"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
const textColor = "#0d2561"
const itextColor = "#707070"

export default function SubmittedPropertiesStatusWidget() {
  const data = {
    offersReceived: 20,
    activeOffers: 12,
    noLongerActive: 8,
  }

  return (
    <Card>
      
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1, fontSize:'1.20rem' }}>
          Submitted Properties Status
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Number of offers received, their status (active/no longer active).
        </Typography>
        <Box mt={2} display="flex" flexDirection="column" gap={2}>
          <Box>
            <Box display="flex" alignItems="center" gap={2}>
              
               <DollarSign style={{width:'20px',height:'20px'}} />
              
              <Typography variant="h6" color="primary" sx={{ color: textColor,fontSize:'18px',fontWeight:'bold' }}>
                {data.offersReceived}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              Offers Received
            </Typography>
          </Box>

          <Box>
            <Box display="flex" alignItems="center" gap={2}>
               <CheckCircle style={{ color: "#16a34a",fontWeight:600, width:'20px',height:'20px' }} />
              
              <Typography variant="h6" sx={{ color: "#16a34a",fontSize:'18px',fontWeight:'bold' }}>
                {data.activeOffers}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              Active Offers
            </Typography>
          </Box>

          <Box sx={{marginBottom:'95px'}}>
            <Box display="flex" alignItems="center" gap={2}>
              <XCircle style={{ color: "#dc2626",fontWeight:600, width:'20px',height:'20px' }} />
             
              <Typography variant="h6" sx={{ color: "#dc2626",fontSize:'18px',fontWeight:'bold' }}>
                {data.noLongerActive}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              No Longer Active
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
